import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const getHomeMaintenancePlansApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunction(data, apiConstants.HOME_MAINTENANCE.GET_HOME_MAINTENANCE_PLANS)
            .then((response) => {
                callback && callback(response.data)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}
